export const payerMap = {
  UHC: "#0ea5e9",
  "UnitedHealthcare (UHG)": "#0ea5e9",
  Humana: "#06b6d4",
  Cigna: "#f97316",
  BCBS: "#3b82f6",
  "Blue Cross Blue Shield": "#3b82f6",
  MVP: "#047857",
  "MVP Health Care": "#047857",
  Aetna: "#8b5cf6",
  "Aetna (CVS Health)": "#8b5cf6",
  Anthem: "#1d4ed8",
  "Anthem / Elevance Health": "#1d4ed8",
  Centene: "#0ea5e9",
  Molina: "#0284c7",
};

export const payerOptions = [
  "UnitedHealthcare (UHG)",
  "Humana",
  "Cigna",
  "Blue Cross Blue Shield",
  "MVP Health Care",
  "Aetna (CVS Health)",
  "Anthem / Elevance Health",
  "Centene",
  "Molina",
];

export const sourceOptions = [
  { label: "Payer / ACO", value: "PAYER" },
  { label: "AI & Scribe", value: "AI" },
];

export const statusOptions = ["New", "Active", "Rejected", "Closed"];
